import FontBody3 from "../../../../../components/fonts/font-body3/font-body3";
import {
    FONT_COLOR,
    FONT_VARIANT,
} from "../../../../../components/fonts/font-props";

/** Decorative stand-ins rendered blurred before the merchant reveals the real values. */
export const MASKED_SHOPPER_NAME_PLACEHOLDER = "Customer Name";
export const MASKED_SHIPPING_ADDRESS_PLACEHOLDER = "Customer Address";

interface IProps {
    text: string;
    variant?: FONT_VARIANT.DEFAULT | FONT_VARIANT.BOLD;
}

const RmaShopperBlurredPlaceholder: React.FC<IProps> = ({
    text,
    variant = FONT_VARIANT.BOLD,
}) => (
    <span className="rma-shopper-blurred-placeholder" aria-hidden="true">
        <FontBody3 color={FONT_COLOR.PRIMARY2} variant={variant}>
            {text}
        </FontBody3>
    </span>
);

export default RmaShopperBlurredPlaceholder;
